import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F4501EC3-6AB0-4A69-B840-F07DDFC45A19
 * name scale-bathroom
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/scale-bathroom.svg
 * tags
 * - Home Automation 
 * - Medical / Hospital 
 */
export const ScaleBathroomIcon = createSvgIcon(<><path d="M5,2H19A2,2 0 0,1 21,4V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2M12,4A4,4 0 0,0 8,8H11.26L10.85,5.23L12.9,8H16A4,4 0 0,0 12,4M5,10V20H19V10H5Z" /></>, 'ScaleBathroomIcon');
export default ScaleBathroomIcon